import React from 'react';
import PanelWrapper from "../PanelWrapper.js";

/**
 * Shared wrapper for chart panels. Handles data fetching, loading, error, and
 * empty-state rendering. Passes panelData to the children render function.
 *
 * This is a wrapper around PanelWrapper with showDescription=true by default.
 *
 * Usage:
 *   <ChartPanelWrapper chart={chart}>
 *     {(panelData) => <MyChart data={transform(panelData)} options={opts} />}
 *   </ChartPanelWrapper>
 */
const ChartPanelWrapper = ({ chart, children }) => {
    return (
        <PanelWrapper panel={chart} showDescription={true}>
            {(panelData) => children(panelData)}
        </PanelWrapper>
    );
};

export default ChartPanelWrapper;
